import { campaign, basic } from 'api';
import {
  UI_GET_MASTER_DATA,
  UI_GET_TOWNS_BY_CP,
  UI_UPDATE_TOWNS_BY_CP_CACHE,
  UI_UPDATE_MASTER_DATA,
  UI_SET_LOADER,
  UI_SET_LOADER_TEXT,
  GET_MARKDOWN_FILE,
  SET_UI_PROPERTY
} from 'store/actions/ui';

export default {
  [UI_GET_MASTER_DATA]: ({ commit, getters }) =>
    new Promise((resolve, reject) => {
      if (!getters.hasMasterData) {
        campaign.getMasterData().then(
          resp => {
            commit(UI_UPDATE_MASTER_DATA, resp.data);
            resolve();
          },
          err => {
            commit('ERROR_OCCURRED', err, { root: true });
            reject();
          }
        );
      } else {
        resolve();
      }
    }),

  [UI_GET_TOWNS_BY_CP]: ({ state, commit }, cp) =>
    new Promise((resolve, reject) => {
      const townsCache = state.townsCache;
      const townsByCpCache = townsCache[cp];
      if (townsByCpCache !== undefined && townsByCpCache.length > 0) {
        return resolve(townsByCpCache);
      }
      campaign.getTownsByCp(cp).then(
        resp => {
          const towns = resp.data;
          commit(UI_UPDATE_TOWNS_BY_CP_CACHE, { cp, towns });
          resolve(towns);
        },
        err => {
          commit('ERROR_OCCURRED', err, { root: true });
          reject();
        }
      );
    }),

  [UI_SET_LOADER]: ({ commit }, loading) => {
    commit(UI_SET_LOADER, loading);
  },

  [UI_SET_LOADER_TEXT]: ({ commit }, text) => {
    commit(UI_SET_LOADER_TEXT, text);
  },

  [SET_UI_PROPERTY]: ({ commit }, { field, value }) =>
    commit(SET_UI_PROPERTY, {
      field,
      value
    }),

  [GET_MARKDOWN_FILE]: ({ commit, getters }, { url, field }) =>
    new Promise((resolve, reject) => {
      if (!getters.dataUI(field)) {
        basic.getMarkdownFile(url).then(
          resp => {
            const data = resp.data;
            commit(SET_UI_PROPERTY, {
              field,
              value: data
            });
            resolve();
          },
          err => {
            commit('ERROR_OCCURRED', err, { root: true });
            reject();
          }
        );
      } else {
        resolve();
      }
    })
};
